import React from 'react';
import classNames from 'classnames';
import styles from './prenav.scss';

import { TopLinks } from '../../link-list/TopLinks';
import type { Link } from '../../types';
import { PrenavCarousel } from './PrenavCarousel';

interface PrenavProps {
  isFocused?: boolean;
  isStickyHeaderActive?: boolean;
  onFocus?: (() => void) | null;
  topLinksData?: Link[];
}

export const Prenav = ({
  isFocused = false,
  isStickyHeaderActive = false,
  onFocus = null,
  topLinksData = [],
}: PrenavProps) => {
  return (
    <div
      className={classNames(styles.topBar, {
        [styles.topBar__collapsed]: isFocused || isStickyHeaderActive,
      })}
      data-testid="header-top-bar"
      onFocus={onFocus || undefined}
    >
      <div className={styles.pageContainer}>
        <div className={styles.grid}>
          <div
            className={classNames(styles.topLinks)}
            data-testid="header-top-links"
          >
            <span
              className={classNames(styles.prenavItem, styles.nkuContainer)}
            >
              <a
                href="/content/never-knowingly-undersold"
                className={styles.nkuLink}
              >
                NEVER KNOWINGLY UNDERSOLD
              </a>
            </span>
            <PrenavCarousel className={styles.prenavItem} />
            <TopLinks className={styles.prenavItem} links={topLinksData} />
          </div>
        </div>
      </div>
    </div>
  );
};
